import React from 'react'
import { Button } from '@abroad/components'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const defaultButtonProps = {
  type: 'button',
  className: 'mr-3 secondary-popup-button px-3 me-3',
  variant: 'secondary-light',
}

/**
 * "Preview Email" button that explains itself when disabled
 * @param {Object} props
 * @param {string} props.disabledReason - Why the preview is unavailable, empty when enabled
 * @param {Function} props.onClick - Opens the preview
 * @param {Function} [props.ButtonComponent] - Button to render, defaults to the shared Button
 * @param {Object} [props.buttonProps] - Props for ButtonComponent
 * @param {string} [props.wrapperClassName] - Class for the span that carries the tooltip
 */
const SOWEmailPreviewButton = ({
  disabledReason,
  onClick,
  ButtonComponent = Button,
  buttonProps = defaultButtonProps,
  wrapperClassName = 'd-inline-block mr-3',
}) => {
  const button = (
    <ButtonComponent
      {...buttonProps}
      disabled={Boolean(disabledReason)}
      // The popup button class forces its colours, so the disabled state is set here
      style={
        disabledReason ? { opacity: 0.4, pointerEvents: 'none' } : undefined
      }
      onClick={onClick}>
      Preview Email
    </ButtonComponent>
  )

  if (!disabledReason) {
    return button
  }

  // Disabled buttons do not fire hover events, so the tooltip is on a wrapper span
  return (
    <OverlayTrigger
      placement='top'
      overlay={
        <Tooltip className='font-open-sans font-16 font-semibold leading-7 text-center header-tooltip inviteonly-content-text modal-tooltip'>
          {disabledReason}
        </Tooltip>
      }>
      <span className={wrapperClassName} style={{ cursor: 'not-allowed' }}>
        {button}
      </span>
    </OverlayTrigger>
  )
}

export default SOWEmailPreviewButton
